import { useState, useEffect } from 'react';

const useAppSettings = () => {
  const [homepageData, setHomepageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomepageSettings = async () => {
      try {
        setLoading(true);
        const wpUrl =
          process.env.REACT_APP_WORDPRESS_URL || 'http://localhost:8080';
        const response = await fetch(`${wpUrl}/wp-json/wp/v2/app-settings`);

        if (response.ok) {
          const data = await response.json();
          setHomepageData(data);
        } else {
          throw new Error('Failed to fetch homepage settings');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching app settings:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchHomepageSettings();
  }, []);

  return {
    homepageData,
    loading,
    error
  };
};

export default useAppSettings;